var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeyondAerospace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "phone:w-2/3 tablet:w-96",
    viewBox: "0 0 313 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.499 234.748C204.516 234.748 243.442 195.822 243.442 147.804C243.442 99.7866 204.516 60.8606 156.499 60.8606C108.481 60.8606 69.5551 99.7866 69.5551 147.804C69.5551 195.822 108.481 234.748 156.499 234.748Z",
    stroke: "#FF5A32",
    strokeWidth: 26.6666,
    strokeMiterlimit: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.501 43.4727L139.11 86.9408L156.501 104.332L173.886 86.9408L156.501 43.4727Z",
    fill: "#A1ABAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.497 269.527L173.888 156.501L156.497 126.069L139.112 156.501L156.497 269.527Z",
    fill: "#A1ABAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 95.637H313L156.5 147.804L0 95.637Z",
    fill: "#A1ABAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.497 60.8612L147.804 86.9445L156.497 95.6369L165.195 86.9445L156.497 60.8612Z",
    fill: "url(#paint0_linear_14_24)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.501 230.403L165.193 156.496L156.501 141.719L147.802 156.496L156.501 230.403Z",
    fill: "url(#paint1_linear_14_24)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.832 104.333L173.89 132.502L163.455 117.375L178.233 104.333H260.832Z",
    fill: "url(#paint2_linear_14_24)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1654 104.333L139.108 132.502L149.542 117.375L134.765 104.333H52.1654Z",
    fill: "url(#paint3_linear_14_24)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_24",
    x1: -43.8761,
    y1: -131.433,
    x2: -43.8761,
    y2: -114.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_24",
    x1: 302.965,
    y1: 368.788,
    x2: 302.965,
    y2: 351.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_24",
    x1: 390.525,
    y1: 261.581,
    x2: 362.356,
    y2: 261.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#157167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_24",
    x1: -77.5274,
    y1: 261.581,
    x2: -49.3584,
    y2: 261.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E2E1"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "phone:w-2/3 tablet:w-96",
    viewBox: "0 0 313 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.499 234.748C204.516 234.748 243.442 195.822 243.442 147.804C243.442 99.7866 204.516 60.8606 156.499 60.8606C108.481 60.8606 69.5551 99.7866 69.5551 147.804C69.5551 195.822 108.481 234.748 156.499 234.748Z",
    stroke: "#FF5A32",
    strokeWidth: 26.6666,
    strokeMiterlimit: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.501 43.4727L139.11 86.9408L156.501 104.332L173.886 86.9408L156.501 43.4727Z",
    fill: "#A1ABAA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.497 269.527L173.888 156.501L156.497 126.069L139.112 156.501L156.497 269.527Z",
    fill: "#A1ABAA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 95.637H313L156.5 147.804L0 95.637Z",
    fill: "#A1ABAA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.497 60.8612L147.804 86.9445L156.497 95.6369L165.195 86.9445L156.497 60.8612Z",
    fill: "url(#paint0_linear_14_24)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.501 230.403L165.193 156.496L156.501 141.719L147.802 156.496L156.501 230.403Z",
    fill: "url(#paint1_linear_14_24)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.832 104.333L173.89 132.502L163.455 117.375L178.233 104.333H260.832Z",
    fill: "url(#paint2_linear_14_24)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1654 104.333L139.108 132.502L149.542 117.375L134.765 104.333H52.1654Z",
    fill: "url(#paint3_linear_14_24)"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_24",
    x1: -43.8761,
    y1: -131.433,
    x2: -43.8761,
    y2: -114.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_24",
    x1: 302.965,
    y1: 368.788,
    x2: 302.965,
    y2: 351.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_24",
    x1: 390.525,
    y1: 261.581,
    x2: 362.356,
    y2: 261.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#157167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_24",
    x1: -77.5274,
    y1: 261.581,
    x2: -49.3584,
    y2: 261.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A1ABAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E2E1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyondAerospace);
export default __webpack_public_path__ + "static/media/beyond_aerospace.ddbc17a8aa333d5e4dddd53786838738.svg";
export { ForwardRef as ReactComponent };